// extracted by mini-css-extract-plugin
export default {"toggle-container":"SortToggle_toggle-container__-0nCn","toggle-half":"SortToggle_toggle-half__URQwO","sortable":"SortToggle_sortable__OkQrP"};